export const IMPORT_STATUS = {
  ERROR: 'error',
  IDLE: 'idle',
  READY: 'ready',
  PROCESSING: 'processing',
  SUCCESS: 'success',
};

export const IMPORT_STATUS_LABEL = {
  [IMPORT_STATUS.READY]: 'Ready to Import',
  [IMPORT_STATUS.PROCESSING]: 'Loading',
  [IMPORT_STATUS.SUCCESS]: 'Complete',
};

export const ACCEPTED_FILE_FORMATS = ['text/csv'];

export const INVALID_FILE_MESSAGES = {
  TYPE: 'Invalid file format. Only CSV files are accepted',
};
